@if (data(); as data) {
  <app-alerts />

  <app-admin-subscription-form
    [data]="data"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
